import React, { useEffect, useState } from 'react';
import { Localized } from '@fluent/react';
import { trackNav } from '../../services/tracker';
import URLS from '../../urls';
import ShareButtons from '../share-buttons/share-buttons';
import { ContactIcon, DiscourseIcon, SupportIcon } from '../ui/icons';
import { TextButton } from '../ui/ui';
import { LocaleLink, useLocale } from '../locale-helpers';
import FooterLogo from './footer-logo';
import SubscribeNewsletter from './subscribe-newsletter';
import { ContactLink, DiscourseLink, GitHubLink } from '../shared/links';

import './footer.css';
import API from '../../services/api';

declare const __FRONTEND_VERSION: string;

const LocalizedLocaleLink = ({ id, to }: { id: string; to: string }) => {
  const [locale] = useLocale();
  return (
    <Localized id={id}>
      <LocaleLink to={to} onClick={() => trackNav(id, locale)} />
    </Localized>
  );
};

export default React.memo((props: { api: API }) => {
  const [backendVersion, setBackendVersion] = useState<string>(null);

  useEffect(() => {
    props.api.getBackendVersion().then(res => {
      if (res.message) {
        setBackendVersion(res.message);
      }
    });
  }, []);

  let versionToDisplay = 'unknown';
  try {
    versionToDisplay = __FRONTEND_VERSION;
  } catch (error) {
    console.log('Cannot get version of application.');
  }

  const [locale] = useLocale();
  return (
    <footer>
      <div id="moz-links">
        <div className="logo-container">
          <FooterLogo />
        </div>
        <div className="divider-bottom" />
        <div className="links">
          <div>
            {/* <LocalizedLocaleLink id="privacy" to={URLS.PRIVACY} /> */}
            {/* <LocalizedLocaleLink id="terms" to={URLS.TERMS} /> */}
            {/* <Localized id="cookies">
              <a
                target="_blank"
                href="https://www.mozilla.org/en-US/privacy/websites/#cookies"
                rel="noopener noreferrer"
              />
            </Localized> */}
          </div>

          <div>
            <span>
              v. {versionToDisplay} {backendVersion && '/ ' + backendVersion}
            </span>
          </div>
        </div>

        {/* <div id="sharing">
          <Localized id="share-title">
            <span className="title" />
          </Localized>

          <div className="icons">
            <ShareButtons />
          </div>
        </div>

        <div id="email-subscription">
          <SubscribeNewsletter />
        </div> */}

        <Localized id="back-top">
          <TextButton
            className="back-top"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
          />
        </Localized>
      </div>
    </footer>
  );
});
